"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("./Button"));

var _utils = require("../utils");

var _dxcFlex = _interopRequireDefault(require("dxc-flex"));

var _dxcScrollMenu = _interopRequireDefault(require("dxc-scroll-menu"));

var _Theme4Button = _interopRequireDefault(require("../../assets/Theme4Button.css"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _onResize = _interopRequireDefault(require("../onResize"));

var _LeftArrow = _interopRequireDefault(require("./LeftArrow"));

var _RightArrow = _interopRequireDefault(require("./RightArrow"));

var _rgbaToObject = _interopRequireDefault(require("../rgbaToObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_Theme4Button["default"]);

var CustomButton = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(CustomButton, _React$PureComponent);

  function CustomButton() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      data: []
    });

    _defineProperty(_assertThisInitialized(_this), "initData", function () {
      var customButton = _this.props.customButton;
      var data = [];

      for (var index = 0; index < customButton.length; index++) {
        var row = customButton[index];

        var temp = _extends({}, row);

        temp._id = index;

        if (temp.children) {
          temp.children.forEach(function (row, index) {
            row._id = index;
          });
        }

        data.push(temp);
      }

      _this.setState({
        data: data
      }, _this.tipRebuild);
    });

    _defineProperty(_assertThisInitialized(_this), "tipRebuild", function () {
      var disableTip = _this.props.disableTip;
      if (disableTip) return;

      _reactTooltip["default"].rebuild();
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (row, index) {
      var _this$props = _this.props,
          handleClick = _this$props.handleClick,
          onClickGroup = _this$props.onClickGroup,
          onCloseGroup = _this$props.onCloseGroup;

      if (row.type === 0) {
        onClickGroup && onClickGroup(index);
      } else {
        var temp = row.children[0];
        onCloseGroup();
        handleClick(temp);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickChildren", function (row) {
      var handleClick = _this.props.handleClick;
      handleClick(row);
    });

    _defineProperty(_assertThisInitialized(_this), "renderArrowRight", function (disable, onClick) {
      if (disable) return null;
      var _this$props$ui = _this.props.ui,
          ui = _this$props$ui === void 0 ? {} : _this$props$ui;
      var colorObj = (0, _rgbaToObject["default"])(ui.fontColor);
      var fill = colorObj.r + "," + colorObj.g + "," + colorObj.b + "," + colorObj.a * 0.8;
      return /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
        onClick: onClick,
        horizontal: "center",
        vertical: "center",
        className: cx("MenuArrowRight")
      }, /*#__PURE__*/_react["default"].createElement(_RightArrow["default"], {
        size: 16,
        fill: "rgba(" + fill + ")"
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderArrowLeft", function (disable, onClick) {
      if (disable) return null;
      var _this$props$ui2 = _this.props.ui,
          ui = _this$props$ui2 === void 0 ? {} : _this$props$ui2;
      var colorObj = (0, _rgbaToObject["default"])(ui.fontColor);
      var fill = colorObj.r + "," + colorObj.g + "," + colorObj.b + "," + colorObj.a * 0.8;
      return /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
        onClick: onClick,
        horizontal: "center",
        vertical: "center",
        className: cx("MenuArrowLeft")
      }, /*#__PURE__*/_react["default"].createElement(_LeftArrow["default"], {
        size: 16,
        fill: "rgba(" + fill + ")"
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderItem", function (row, index) {
      var _this$props2 = _this.props,
          language = _this$props2.language,
          activityGroup = _this$props2.activityGroup,
          disableTip = _this$props2.disableTip,
          _this$props2$ui = _this$props2.ui,
          ui = _this$props2$ui === void 0 ? {} : _this$props2$ui;
      var data;

      if (row.type === 0) {
        data = row;
      } else {
        data = row.children[0];
      }

      var title = (0, _utils.getLinkTitle)(data, language);
      var style = {};

      if (index === 0) {
        // style.margin-right
        style.marginLeft = 0;
      }

      return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        color: ui.fontColor,
        data: data,
        style: style,
        dataTip: disableTip ? undefined : title,
        onClick: _this.onClick.bind(_assertThisInitialized(_this), row, index),
        key: index,
        selected: activityGroup === index
      }, title);
    });

    _defineProperty(_assertThisInitialized(_this), "renderChildrenItem", function (row, index) {
      var _this$props3 = _this.props,
          language = _this$props3.language,
          disableTip = _this$props3.disableTip,
          _this$props3$ui = _this$props3.ui,
          ui = _this$props3$ui === void 0 ? {} : _this$props3$ui;
      var title = (0, _utils.getLinkTitle)(row, language);
      return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        color: ui.fontColor,
        data: row,
        dataTip: disableTip ? undefined : title,
        onClick: _this.onClickChildren.bind(_assertThisInitialized(_this), row, index),
        key: index
      }, title);
    });

    _defineProperty(_assertThisInitialized(_this), "renderChildren", function () {
      var _this$props4 = _this.props,
          activityGroup = _this$props4.activityGroup,
          size = _this$props4.size,
          language = _this$props4.language,
          _this$props4$ui = _this$props4.ui,
          ui = _this$props4$ui === void 0 ? {} : _this$props4$ui;
      var maxNum = size.isMobile ? 4 : 6;
      var data = _this.state.data;
      var items = data[activityGroup] || {
        children: []
      }; // if (items.children.length <= maxNum) {
      //   return (
      //   );
      // } else {
      //   return (
      //     <div key='renderChildren' className={cx('Theme4CustomButton', { isOpen: items.children.length > 0, animation: true })}>
      //       {/* <ScrollMenu selected={activityGroup} renderItem={this.renderChildrenItem} data={items.children}></ScrollMenu> */}
      //     </div>
      //   );
      // }

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          background: ui.panelBgColor
        },
        className: cx("Theme4CustomButton", {
          isOpen: items.children.length > 0,
          animation: true
        })
      }, items.children.length <= maxNum ? /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
        key: "renderChildren",
        horizontal: "around"
      }, items.children.map(_this.renderChildrenItem)) : /*#__PURE__*/_react["default"].createElement(_dxcScrollMenu["default"], {
        itemData: language,
        selected: activityGroup,
        renderItem: _this.renderChildrenItem,
        data: items.children
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var style = _this.props.style;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, _this.renderChildren(), _this.renderFather());
    });

    return _this;
  }

  var _proto = CustomButton.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.initData();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var customButton = this.props.customButton;
    var prevCustomButton = prevProps.customButton;

    if (customButton !== prevCustomButton) {
      this.initData();
    }
  };

  _proto.renderFather = function renderFather() {
    var data = this.state.data;
    var _this$props5 = this.props,
        size = _this$props5.size,
        _this$props5$ui = _this$props5.ui,
        ui = _this$props5$ui === void 0 ? {} : _this$props5$ui;
    var maxNum = size.isMobile ? 4 : 6;

    if (data.length <= maxNum) {
      return /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
        style: {
          background: ui.panelBgColor
        },
        horizontal: "around",
        className: cx("Theme4CustomButton", {
          father: true
        })
      }, data.map(this.renderItem));
    }

    var _this$props6 = this.props,
        activityGroup = _this$props6.activityGroup,
        language = _this$props6.language;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        background: ui.panelBgColor
      },
      className: cx("Theme4CustomButton", {
        father: true
      })
    }, /*#__PURE__*/_react["default"].createElement(_dxcScrollMenu["default"], {
      itemData: _extends({}, language, ui),
      arrowRight: this.renderArrowRight,
      arrowLeft: this.renderArrowLeft,
      selected: activityGroup,
      renderItem: this.renderItem,
      data: data
    }));
  };

  return CustomButton;
}(_react["default"].PureComponent);

var _default = (0, _onResize["default"])({
  "default": {
    isMobile: false
  },
  1024: {
    isMobile: true
  }
})(CustomButton);

exports["default"] = _default;
module.exports = exports.default;